module.exports = __webpack_public_path__ + "static/media/twLogo.250101fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/twLogo.png
// module id = 685
// module chunks = 11